"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
const $a5fd07fa01589658$var$MAX_FIELDS = 4;
const $a5fd07fa01589658$var$WIN_SCORE = 2048;
class $a5fd07fa01589658$var$Game {
    /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state
   */ constructor(initialState = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ]){
        // eslint-disable-next-line no-console
        console.log(initialState);
        if (Array.isArray(initialState) && initialState.length === $a5fd07fa01589658$var$MAX_FIELDS && initialState.every((e)=>e.length === $a5fd07fa01589658$var$MAX_FIELDS)) {
            this.initialState = initialState;
            this.score = 0;
            this.status = "idle";
        }
    }
    moveLeft() {
        if (this.getStatus() !== "lose") {
            const previousState = JSON.stringify(this.initialState);
            const { result: result, score: score } = $a5fd07fa01589658$var$Game.#shiftLeft(this.initialState);
            this.score += score;
            this.initialState = result;
            if (previousState !== JSON.stringify(this.initialState)) this.#crateField();
            this.#changeFinalStatus();
        }
    }
    moveRight() {
        if (this.getStatus() !== "lose") {
            const previousState = JSON.stringify(this.initialState);
            const tempMatrix = $a5fd07fa01589658$var$Game.#reverse(this.initialState);
            const { result: result, score: score } = $a5fd07fa01589658$var$Game.#shiftLeft(tempMatrix);
            this.score += score;
            this.initialState = $a5fd07fa01589658$var$Game.#reverse(result);
            if (previousState !== JSON.stringify(this.initialState)) this.#crateField();
            this.#changeFinalStatus();
        }
    }
    moveDown() {
        if (this.getStatus() !== "lose") {
            const previousState = JSON.stringify(this.initialState);
            let tempMatrix = $a5fd07fa01589658$var$Game.#transposition(this.initialState);
            tempMatrix = $a5fd07fa01589658$var$Game.#reverse(tempMatrix);
            const { result: result, score: score } = $a5fd07fa01589658$var$Game.#shiftLeft(tempMatrix);
            this.score += score;
            tempMatrix = $a5fd07fa01589658$var$Game.#reverse(result);
            this.initialState = $a5fd07fa01589658$var$Game.#transposition(tempMatrix);
            if (previousState !== JSON.stringify(this.initialState)) this.#crateField();
            this.#changeFinalStatus();
        }
    }
    moveUp() {
        if (this.getStatus() !== "lose") {
            const previousState = JSON.stringify(this.initialState);
            const tempMatrix = $a5fd07fa01589658$var$Game.#transposition(this.initialState);
            const { result: result, score: score } = $a5fd07fa01589658$var$Game.#shiftLeft(tempMatrix);
            this.score += score;
            this.initialState = $a5fd07fa01589658$var$Game.#transposition(result);
            if (previousState !== JSON.stringify(this.initialState)) this.#crateField();
            this.#changeFinalStatus();
        }
    }
    static #shiftLeft(matrix) {
        let score = 0;
        const result = structuredClone(matrix);
        for(let i = 0; i < result.length; i++){
            let row = result[i].filter((e)=>e !== 0);
            for(let m = 0, n = m + 1; n < row.length; n++, m++)if (row[m] === row[n]) {
                row[m] *= 2;
                score += row[m];
                row[n] = 0;
            }
            row = row.filter((e)=>e !== 0);
            while(result[i].length !== row.length)row.push(0);
            result[i] = row;
        }
        return {
            result: result,
            score: score
        };
    }
    static #transposition(result) {
        for(let i = 0; i < result.length; i++)for(let j = i + 1; j < result[i].length; j++)[result[i][j], result[j][i]] = [
            result[j][i],
            result[i][j]
        ];
        return result;
    }
    static #reverse(matrix) {
        return matrix.map((r)=>[
                ...r
            ].reverse());
    }
    /**
   * @returns {number}
   */ getScore() {
        return this.score;
    }
    /**
   * @returns {number[][]}
   */ getState() {
        return this.initialState;
    }
    /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ getStatus() {
        return this.status;
    }
    /**
   * Starts the game.
   */ start() {
        this.status = "playing";
        this.#crateField();
        this.#crateField();
    }
    #crateField() {
        const emptyCells = [];
        for(let i = 0; i < this.initialState.length; i++){
            for(let j = 0; j < this.initialState[i].length; j++)if (this.initialState[i][j] === 0) emptyCells.push({
                x: i,
                y: j
            });
        }
        if (emptyCells.length === 0) return;
        const randomIndex = Math.floor(Math.random() * emptyCells.length);
        const { x: x, y: y } = emptyCells[randomIndex];
        this.initialState[x][y] = Math.random() > 0.9 ? 4 : 2;
    }
    /**
   * Resets the game.
   */ restart() {
        this.initialState = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.score = 0;
        this.status = "playing";
        this.#crateField();
        this.#crateField();
    }
    #changeFinalStatus() {
        const hasWon = this.initialState.some((e)=>e.includes($a5fd07fa01589658$var$WIN_SCORE));
        if (hasWon) {
            this.status = "win";
            return;
        }
        if (this.#isLose()) this.status = "lose";
    }
    #isLose() {
        for(let i = 0; i < this.initialState.length; i++)for(let j = 0; j < this.initialState[i].length; j++){
            if (this.initialState[i][j] === 0) return false;
            if (j < this.initialState[i].length - 1 && this.initialState[i][j] === this.initialState[i][j + 1]) return false;
            if (i < this.initialState.length - 1 && this.initialState[i][j] === this.initialState[i + 1][j]) return false;
        }
        return true;
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$mainButton = document.querySelector(".button");
const $09e991522ca7e64e$var$gameScore = document.querySelector(".game-score");
const $09e991522ca7e64e$var$gameField = document.querySelector(".game-field");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
let $09e991522ca7e64e$var$previousState = null;
$09e991522ca7e64e$var$mainButton.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$mainButton.classList.contains("start")) {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$mainButton.textContent = "Restart";
        $09e991522ca7e64e$var$mainButton.classList.remove("start");
        $09e991522ca7e64e$var$mainButton.classList.add("restart");
        $09e991522ca7e64e$var$messageStart.classList.add("hidden");
    } else $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$messageWin.classList.add("hidden");
    $09e991522ca7e64e$var$messageLose.classList.add("hidden");
    $09e991522ca7e64e$var$gameScore.textContent = $09e991522ca7e64e$var$game.getScore();
    $09e991522ca7e64e$var$update();
});
document.addEventListener("keydown", (e)=>{
    e.preventDefault();
    switch(e.key){
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            break;
    }
    $09e991522ca7e64e$var$update();
    switch($09e991522ca7e64e$var$game.getStatus()){
        case "win":
            $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
            break;
        case "lose":
            $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
            break;
    }
});
function $09e991522ca7e64e$var$update() {
    const fields = $09e991522ca7e64e$var$game.getState();
    [
        ...$09e991522ca7e64e$var$gameField.rows
    ].forEach((row, i)=>{
        [
            ...row.cells
        ].forEach((cell, j)=>{
            const currentValue = fields[i][j];
            const prevValue = $09e991522ca7e64e$var$previousState ? $09e991522ca7e64e$var$previousState[i][j] : 0;
            cell.textContent = "";
            cell.className = "field-cell";
            if (currentValue !== 0) {
                cell.textContent = currentValue;
                cell.classList.add(`field-cell--${currentValue}`);
                if (prevValue === 0) cell.classList.add("field-cell--new");
                else if (prevValue !== currentValue) cell.classList.add("field-cell--merged");
            }
        });
    });
    $09e991522ca7e64e$var$gameScore.textContent = $09e991522ca7e64e$var$game.getScore();
    $09e991522ca7e64e$var$previousState = fields.map((row)=>[
            ...row
        ]);
}


//# sourceMappingURL=index.62841d14.js.map
